module LogData {
    export function Init() {
        var dataTableSettings: DataTables.Settings = {
            pageLength: 25,
            order: [[0, 'desc']],
            scrollX: false,
            scrollY: '70vh',
            columns: [
                { data: 0, title: 'Datum' },
                { data: 1, title: 'Korisnik' },
                { data: 2, title: 'Akcija' },
                { data: 3, title: 'Opis', className: 'dt-left text-wrap' }
            ]
        };

        Common.DataTableCustom.Init('logTable', dataTableSettings, [], '/DBLogs/ListData');
    }
}